import {Component, OnInit} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {Order} from "../../../../../../common/interfaces/order.interface";


@Component({
    selector: "section-order-list-type-rma",
    template: `
        <section-order-list [params]="params"></section-order-list>`
})
export class OrderListTypeRmaComponent implements Base.IComponent, OnInit {

    public readonly state: Base.IState;

    public params: Order.IOrderListParams;

    public constructor() {
    }

    public ngOnInit(): void {
        this.params = {
            title: "RMA orders list",
            state: this.state,
            actions: {
                view: true,
                delete: true,
                add: false,
                export: true,
                remarks: true
            },
            query: {order_type: "rma"}
        };
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "orders-type-rma",
            actions: {
                "browse": ["browse_orders"]
            }
        };
    }

}
